import React from 'react';
import Heart from 'lucide-react/dist/esm/icons/heart.js';
import Users from 'lucide-react/dist/esm/icons/users.js';
import TrendingUp from 'lucide-react/dist/esm/icons/trending-up.js';
import { usePurchasePage } from './PurchasePageContext';
import InlineTranslationEdit from '../../../components/InlineTranslationEdit';
import { useContent } from '../../../contexts/ContentContext';
import { useTranslations } from '../../../contexts/TranslationContext';

export default function PurchaseCharityCardSection({ section, config }) {
  const { siteDetails } = usePurchasePage();
  const { c } = useContent();
  const { t: tr } = useTranslations();

  const charityName = siteDetails?.charityName || tr('purchase.charity.defaultName', 'Local Charity');
  const charityDescription = siteDetails?.charityDescription || tr('purchase.charity.defaultDescription', 'Supporting our community');
  const totalRaised = siteDetails?.totalRaised || 0;

  return (
    <div className="bg-gradient-to-br from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-2xl p-6 md:p-8 border-2 border-purple-200 dark:border-purple-800 shadow-lg mb-8">
      <div className="flex items-center gap-3 mb-4">
        <div className="bg-purple-600 p-3 rounded-xl">
          <Heart className="w-6 h-6 text-white" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            <InlineTranslationEdit
              translationKey="purchase.charity.title"
              value={c('purchase.charity.title', tr('purchase.charity.title') || 'Supporting Our Community')}
              defaultText="Supporting Our Community"
            />
        </h2>
      </div>

      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-bold text-purple-900 dark:text-purple-300 mb-2">
            {charityName}
          </h3>
          <p className="text-gray-700 dark:text-gray-300 text-sm">
            {charityDescription}
          </p>
        </div>

        {totalRaised > 0 && (
          <div className="bg-white dark:bg-gray-800 rounded-xl p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <TrendingUp className="w-5 h-5 text-green-600" />
                <span className="text-sm text-gray-600 dark:text-gray-400">
                  <InlineTranslationEdit
                    translationKey="purchase.charity.totalRaised"
                    value={c('purchase.charity.totalRaised', tr('purchase.charity.totalRaised') || 'Total Raised')}
                    defaultText="Total Raised"
                  />
                </span>
              </div>
              <span className="text-2xl font-black text-purple-600 dark:text-purple-400">
                ${totalRaised.toLocaleString()}
              </span>
            </div>
          </div>
        )}

        <div className="flex items-start gap-3 bg-purple-100 dark:bg-purple-900/40 rounded-lg p-4">
          <Users className="w-5 h-5 text-purple-600 dark:text-purple-400 mt-0.5 flex-shrink-0" />
          <p className="text-sm text-gray-700 dark:text-gray-300">
            <InlineTranslationEdit
              translationKey="purchase.charity.impact"
              value={c('purchase.charity.impact', tr('purchase.charity.impact') || 'Every ticket you purchase supports local programs and services in our community.')}
              defaultText="Every ticket you purchase supports local programs and services in our community."
            />
          </p>
        </div>
      </div>
    </div>
  );
}
